/**
 * "On this page" rail for a docs page — rendered as a sibling of the page's `.page`
 * column inside `.docs-content` (globals.css .docs-toc). Plain in-page anchors, not
 * scrollIntoView: a copied /docs/x#id URL and print both keep working. Hidden below
 * 900px, where there is no room for a rail.
 */
export interface DocsTocItem {
  id: string;
  label: string;
  /** Optional muted count after the label (e.g. tools in an MCP category). */
  count?: number;
}

export function DocsToc({ items }: { items: DocsTocItem[] }) {
  return (
    <aside className="docs-toc" aria-labelledby="docs-toc-label">
      <div className="kv-k" id="docs-toc-label">
        On this page
      </div>
      <nav className="stack-sm">
        {items.map((it) => (
          <a key={it.id} href={`#${it.id}`}>
            {it.label}
            {it.count !== undefined && <span className="muted text-2xs"> {it.count}</span>}
          </a>
        ))}
      </nav>
    </aside>
  );
}
